/* Common Imports */
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

/* Component Imports */
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  megaContainer: {
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      padding: "0rem 0.5rem 1rem 0.5rem",
    },
    [theme.breakpoints.only("xs")]: {
      padding: "0rem 1.5rem 1rem 1.5rem",
    },
    [theme.breakpoints.only("sm")]: {
      padding: "0rem 3rem 1rem 3rem",
    },
    [theme.breakpoints.only("md")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    [theme.breakpoints.only("lg")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    /* XLG breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.lg + 48)]: {
      padding: "0rem 5rem 1rem 5rem",
    },
    /* Full HD breakpoint */
    [theme.breakpoints.up("xl")]: {
      padding: "0rem 23rem 1rem 23rem",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      padding: "0rem 36rem 1rem 36rem",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      padding: "0rem 72rem 1rem 72rem",
    },

    [theme.breakpoints.down("xs")]: {
      margin: "0rem 0rem 3rem 0rem",
    },
  },
  mainContainer: {
    padding: "4rem 8rem 2rem 8rem",
    // [theme.breakpoints.down("sm")]: {
    //   display: "none",
    // },

    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
    [theme.breakpoints.down("md")]: {
      padding: "0rem 2rem 0rem 2rem",
    },
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "2rem",
    padding: "2rem 0rem 2rem 0rem",
    margin: "2.5rem 0rem 2.5rem 0rem",
    width: "100%",
    [theme.breakpoints.down("lg")]: {
      flexDirection: "column",
      margin: "0.5rem 0rem 0.5rem 0rem",
      gap: "1rem",
    },
  },
  heading: {
    color: "#693471",
    fontWeight: 600,
    fontSize: "2.125rem",
    lineHeight: "2.65rem",
    margin: "0rem 0rem 0.5rem 0rem",
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "2rem",
    },
  },
  subHeading: {
    margin: "0rem 0rem 0.5rem 0rem",
    width: "100%",
    color: "#202020",
    fontWeight: "600",
    fontSize: "1.125rem",
    lineHeight: "1.5rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
      lineHeight: "1.25rem",
    },
  },
  imageGrid: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    gap: "1rem",
    width: "100%",
    margin: "2.5rem 0rem 2.5rem 0rem",
    "& img": {
      width: "605px",
      height: "428px",
      objectFit: "cover",
      borderRadius: "0.5rem",
      [theme.breakpoints.down("lg")]: {
        width: "100%",
        height: "auto",
      },
      cursor: "pointer", // Add pointer cursor for clickable images
    },
  },
  iconTextCard: {
    width: "100%",
    padding: "1.5rem 1.5rem 1.5rem 1.5rem",
    boxShadow: "0px 4px 18px 0px rgba(0, 0, 0, 0.05)",
    borderRadius: "1rem",
    border: "1px solid  rgba(0, 0, 0, 0.12)",

    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  dialog: {
    "& .MuiDialog-paper": {
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.9)",
      borderRadius: "0",
      overflow: "hidden",
      padding: "2rem 4rem 0rem 4rem",
    },
  },
  dialogContent: {
    position: "relative",
    padding: "1rem",
    textAlign: "center",
  },
  closeButton: {
    position: "absolute",
    top: "10px",
    right: "10px",
    color: "#fff", // Set to white for visibility against a dark background
    zIndex: 1000, // Ensure it appears above other elements
  },
  text: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "1rem",
    width: "100%",
  },
  imgdiv: {
    width: "817px",
    height: "577px",
    objectFit: "cover",
    [theme.breakpoints.down("lg")]: {
      width: "600px",
      height: "auto",
    },
  },
  dialogImage: {
    width: "817px",
    height: "577px",
    borderRadius: "0.5rem",
    objectFit: "cover",
    display: "block",
    margin: "auto",
    position: "relative",
  },
  dialogText: {
    marginTop: "1rem",
    fontSize: "1rem",
    color: "#202020",
  },
  dailogHeading: {
    fontSize: "2.125rem",
    fontWeight: "600",
    lineHeight: "2.56rem",
    color: "#ffffff",
  },
  dailogSubHeading: {
    fontSize: "1.125rem",
    fontWeight: "600",
    lineHeight: "1.688rem",
    color: "#ffffff",
  },
  dailogText: {
    fontSize: "1.125rem",
    fontWeight: "400",
    lineHeight: "1.688rem",
    color: "#ffffff",
    margin: "1rem 0rem 1rem 0rem",
  },
  description: {
    fontSize: "1.125rem",
    fontWeight: "400",
    lineHeight: "1.688rem",
    color: "#202020",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
      lineHeight: "1.25rem",
    },
  },
  timeButtons: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "1rem",
  },
  timeButton: {
    padding: "0.5rem 1rem",
    fontSize: "0.813rem",
    fontWeight: "500",
    color: "#693471",
    background: "#FFFFFF",
    border: "1px solid #693471",
    borderRadius: "0.5rem",
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "#693471",
      color: "#FFFFFF",
    },
  },
  activeTimeButton: {
    background: "#693471",
    color: "#FFFFFF",
  },
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "0.5rem",
    [theme.breakpoints.down("lg")]: {
      flexDirection: "column",
      gap: "1rem",
      alignItems: "flex-start",
    },
  },
}));

const FloorPlanSection = () => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(1);
  //   const [open, setOpen] = React.useState(false);

  //   const images = [
  //     {
  //       src: "images/icons/heavie/aboutus/Terrace.webp",
  //       description: "This is the Terrace Floor Plan.",
  //     },
  //     {
  //       src: "images/icons/heavie/aboutus/TypicalFloor.webp",
  //       description: "This is the Typical Floor Plan.",
  //     },
  //     {
  //       src: "images/icons/heavie/aboutus/Ground.webp",
  //       description: "This is the Ground Floor Plan.",
  //     },
  //     {
  //       src: "images/icons/heavie/aboutus/basement.webp",
  //       description: "This is the Basement Floor Plan.",
  //     },
  //   ];

  // Open modal and set active content
  //   const handleOpen = (content) => {
  //     setActiveContent(content);
  //     setOpen(true);
  //   };

  // Close modal
  //   const handleClose = () => {
  //     setOpen(false);
  //   };

  return (
    <React.Fragment>
      <div className={classes.mainContainer}>
        <div className={classes.container}>
          <Typography
            variant="h6"
            component="span"
            className={classes.heading}
          >
            Floor Plans
          </Typography>
          {/* Floor Plan Buttons */}
          <div className={classes.timeButtons}>
            <button
              className={`${classes.timeButton} ${activeStep === 1 ? classes.activeTimeButton : ""}`}
              onClick={() => setActiveStep(1)}
            >
              Basement
            </button>
            <button
              className={`${classes.timeButton} ${activeStep === 2 ? classes.activeTimeButton : ""}`}
              onClick={() => setActiveStep(2)}
            >
              Ground Floor
            </button>
            <button
              className={`${classes.timeButton} ${activeStep === 3 ? classes.activeTimeButton : ""}`}
              onClick={() => setActiveStep(3)}
            >
              Typical Floor
            </button>
            <button
              className={`${classes.timeButton} ${activeStep === 4 ? classes.activeTimeButton : ""}`}
              onClick={() => setActiveStep(4)}
            >
              Terrace
            </button>
          </div>
        </div>
        {/* <div className={classes.imageGrid}>
            {images.map((image, index) => (
              <img
                key={index}
                alt={`eden-floor-plan-${index}`}
                loading="lazy"
                referrerPolicy="no-referrer"
                src={image.src}
                onClick={() => handleOpen(image)}
              />
            ))}
          </div> */}
        {activeStep === 1 && (
          <div className={classes.sectionContainer}>
            <img
              alt="eden-floor-plan-terrace"
              loading="lazy"
              referrerPolicy="no-referrer"
              src="images/icons/heavie/aboutus/basement.webp"
              // onClick={() => handleOpen(images[0])}
              className={classes.imgdiv}
            />
            <div className={classes.text}>
              <Typography
                variant="h6"
                component="h6"
                className={classes.heading}
              >
                Basement
              </Typography>
              <Typography
                variant="h3"
                component="h3"
                className={classes.subHeading}
              >
                All the parking you&apos;ll ever need
              </Typography>
              <Typography
                variant="body2"
                component="span"
                className={classes.description}
              >
                Exclusive electric car charging points with a double height ceiling for every apartment unit.
              </Typography>
            </div>
          </div>
        )}
        {activeStep === 2 && (
          <div className={classes.sectionContainer}>
            <img
              alt="eden-floor-plan-terrace"
              loading="lazy"
              referrerPolicy="no-referrer"
              src="images/icons/heavie/aboutus/Ground.webp"
              // onClick={() => handleOpen(images[0])}
              className={classes.imgdiv}
            />
            <div className={classes.text}>
              <Typography
                variant="h6"
                component="h6"
                className={classes.heading}
              >
                Ground Floor
              </Typography>
              <Typography
                variant="h3"
                component="h3"
                className={classes.subHeading}
              >
                Spacious apartments overlooking green spaces
              </Typography>
              <Typography
                variant="body2"
                component="span"
                className={classes.description}
              >
                Ground floor units give you an opportunity to step into your own private utopia anytime you want.
              </Typography>
            </div>
          </div>
        )}
        {activeStep === 3 && (
          <div className={classes.sectionContainer}>
            <img
              alt="eden-floor-plan-terrace"
              loading="lazy"
              referrerPolicy="no-referrer"
              src="images/icons/heavie/aboutus/TypicalFloor.webp"
              // onClick={() => handleOpen(images[0])}
              className={classes.imgdiv}
            />
            <div className={classes.text}>
              <Typography
                variant="h6"
                component="h6"
                className={classes.heading}
              >
                Typical Floor
              </Typography>
              <Typography
                variant="h3"
                component="h3"
                className={classes.subHeading}
              >
                Spacious apartments with private balconies
              </Typography>
              <Typography
                variant="body2"
                component="span"
                className={classes.description}
              >
                Private residences, holistically planned that are in harmony with nature and it&apos;s elements.
              </Typography>
            </div>
          </div>
        )}
        {activeStep === 4 && (
          <div className={classes.sectionContainer}>
            <img
              alt="eden-floor-plan-terrace"
              loading="lazy"
              referrerPolicy="no-referrer"
              src="images/icons/heavie/aboutus/Terrace.webp"
              // onClick={() => handleOpen(images[0])}
              className={classes.imgdiv}
            />
            <div className={classes.text}>
              <Typography
                variant="h6"
                component="h6"
                className={classes.heading}
              >
                Terrace
              </Typography>
              <Typography
                variant="h3"
                component="h3"
                className={classes.subHeading}
              >
                Leisure Hub
              </Typography>
              <Typography
                variant="body2"
                component="span"
                className={classes.description}
              >
                Live the high life with an infinity swimming pool, barbecue area, bonfire area, yoga deck, gym, and a
                party hall.
              </Typography>
            </div>
          </div>
        )}
      </div>
      {/* Modal */}
      {/* <Dialog
        open={open}
        onClose={handleClose}
        className={classes.dialog}
        fullScreen
      >
        <DialogContent className={classes.dialogContent}>
          <IconButton
            className={classes.closeButton}
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton> */}

      {/* Conditional Rendering for Content */}
      {/* {activeContent.src === "images/icons/heavie/aboutus/Terrace.webp" ? (
            <div className={classes.text}>
              <Typography
                variant="h6"
                component="h6"
                className={classes.dailogHeading}
              >
                Terrace
              </Typography>
              <Typography
                variant="h3"
                component="h3"
                className={classes.dailogSubHeading}
              >
                Leisure Hub
              </Typography>
              <Typography
                variant="body2"
                component="span"
                className={classes.dailogText}
              >
                Live the high life with an infinity swimming pool, barbecue area, bonfire area, yoga deck, gym, and a
                party hall.
              </Typography>
              <img
                src={activeContent.src}
                alt="terrace-floor-plan"
                className={classes.dialogImage}
              />
            </div>
          ) : activeContent.src === "images/icons/heavie/aboutus/Ground.webp" ? (
            <div className={classes.text}>
              <Typography
                variant="h1"
                component="h1"
                className={classes.dailogHeading}
              >
                Ground Floor
              </Typography>
              <Typography
                variant="h3"
                component="h3"
                className={classes.dailogSubHeading}
              >
                Spacious apartments overlooking green spaces
              </Typography>
              <Typography
                variant="body2"
                component="span"
                className={classes.dailogText}
              >
                Ground floor units give you an opportunity to step into your own private utopia anytime you want.
              </Typography>

              <img
                src={activeContent.src}
                alt="ground-floor-plan"
                className={classes.dialogImage}
              />
            </div>
          ) : activeContent.src === "images/icons/heavie/aboutus/basement.webp" ? (
            <div className={classes.text}>
              <Typography
                variant="h1"
                component="h1"
                className={classes.dailogHeading}
              >
                Basement
              </Typography>
              <Typography
                variant="h3"
                component="h3"
                className={classes.dailogSubHeading}
              >
                All the parking you&apos;ll ever need
              </Typography>
              <Typography
                variant="body2"
                component="span"
                className={classes.dailogText}
              >
                Exclusive electric car charging points with a double height ceiling for every apartment unit.
              </Typography>
              <img
                src={activeContent.src}
                alt="basement-floor-plan"
                className={classes.dialogImage}
              />
            </div>
          ) : activeContent.src === "images/icons/heavie/aboutus/TypicalFloor.webp" ? (
            <div className={classes.text}>
              <Typography
                variant="h1"
                component="h1"
                className={classes.dailogHeading}
              >
                Typical Floor
              </Typography>
              <Typography
                variant="h3"
                component="h3"
                className={classes.dailogSubHeading}
              >
                Spacious apartments with private balconies
              </Typography>
              <Typography
                variant="body2"
                component="span"
                className={classes.dailogText}
              >
                Private residences, holistically planned that are in harmony with nature and it&apos;s elements.
              </Typography>
              <img
                src={activeContent.src}
                alt="typical-floor-plan"
                className={classes.dialogImage}
              />
            </div>
          ) : null} */}
      {/* </DialogContent> */}
      {/* </Dialog> */}
    </React.Fragment>
  );
};

export default FloorPlanSection;
